import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import SettingsButton from './SettingsButton';
import media from '../style/media';
import { Flex } from './shared/Flex';

const Wrapper = styled(Flex)`
 
  ${media.tablet`
    padding-left: 100px;
`}
`;

const TopBar = ({ onSettingsClick, isMeasuring }) => {
  return (
    <Wrapper>
      {/* <SettingsButton disable={isMeasuring} onClick={onSettingsClick} />
      <Logo /> */}
    </Wrapper>
  );
};

export default TopBar;
